export default "__VITE_ASSET__BTcZtlTB__"